import React from 'react'
const WebChatIcon = (props) => {
  return (
   <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(1.143 1.143)" stroke="#000" strokeWidth="1.5" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12.857" cy="12.857" r="12.857"/>
        <ellipse cx="12.857" cy="12.857" rx="5.143" ry="12.857"/>
        <ellipse cx="12.857" cy="12.857" rx="12.857" ry="5.143"/>
      </g>
    </svg>
    )
}
export default WebChatIcon
